export default "__VITE_ASSET__eac47c24__"